
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ProCongrats',
  setup() {
    return { }
  }
})
